import axiosInstance from "../../../http-common";

export const load_adhoc_analyst_data = async (setData, analyst_id) => {
  try {
    const result = await axiosInstance.get(
      `/v1/qc/adhoc_schedule/?analyst_id=${analyst_id}`
    );
    // console.log(result);
    if (result.data) {
      const tableData = result?.data?.["adhoc_qc_schedule"];
      // console.log(tableData);
      if (
        result["data"]?.["adhoc_qc_schedule"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {
    // const err = getErrorMessage(error);
    console.log({ error: error });
  }
};
export const load_ongoing_analyst_data = async (setData, analyst_id) => {
  try {
    const result = await axiosInstance.get(
      `/v1/qc/get_ongoing_schedule/?analyst_id=${analyst_id}`
    );
    // console.log(result);
    if (result.data) {
      const tableData = result?.data;
      // console.log(tableData);
      if (result["data"] && setData && typeof setData === "function") {
        setData(tableData);
      }
    }
  } catch (error) {
    // const err = getErrorMessage(error);
    console.log({ error: error });
  }
};
